export const TRANSFER_WORKFLOW_CONTAINER_TAG_NAME = 'transfer-workflow-container';
